import { Typography } from '@mui/material';
import { ColorScheme } from '../../Themes/ColorScheme';

const OnOffSlider = ({action, status, helperText}) => {


  const toggleSwitch = () => {
    action(!status);
  };

  const sliderStyle = {
    position: 'relative',
    display: 'inline-block',
    width: '68px',
    height: '20px',
  };

  const sliderInnerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: status ? ColorScheme.successPrimary : ColorScheme.darkGrey,
    borderRadius: '34px',
    transition: '0.4s',
  };

  const circleStyle = {
    position: 'absolute',
    height: '14px',
    width: '32px',
    left: status ? '32px' : '4px',
    bottom: '3px',
    backgroundColor: 'white',
    borderRadius: '7px',
    transition: '0.4s',
  };

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
      {helperText && <Typography sx={{fontSize: "12px", marginBottom: "5px", fontWeight: "700", whiteSpace: "nowrap"}}>{helperText}</Typography>}
      <div onClick={toggleSwitch} style={sliderStyle}>
        <div style={sliderInnerStyle}></div>
        <div style={circleStyle}></div>
      </div>
    </div>
  );
};

export default OnOffSlider;